import { createStore } from 'vuex';
import abonnement from './stores/abonnement';
import abonnements from './stores/abonnements';
import aboutus from './stores/aboutus.js';
import apitest from './stores/apitest';
import authors from './stores/authors.js';
import cart from './stores/cart';
import cart_products from './stores/cart_products';
import contentpage from './stores/contentpage';
import contentpages from './stores/contentpages';
import contentstream from './stores/contentstream';
import contentstream_types from './stores/contentstream_types';
import contentstream_user from './stores/contentstream_user';
import contentstreams from './stores/contentstreams';
import countries from './stores/countries';
import customers from './stores/customers';
import dashboard_banners from './stores/dashboard_banners';
import discount_promotions from './stores/discount_promotions';
import edit_mode from './stores/edit_mode';
import error from './stores/error';
import invoices from './stores/invoices';
import languages from './stores/languages';
import marketSymbols from './stores/marketSymbols';
import meta from './stores/meta.js';
import order from './stores/order';
import orders from './stores/orders';
import payment_methods from './stores/payment_methods';
import performance from './stores/performance';
import post from './stores/post';
import posts from './stores/posts';
import price_targets from './stores/price_targets';
import product_categories from './stores/product_categories';
import product_group from './stores/product_group';
import product_groups from './stores/product_groups';
import settings from './stores/settings';
import social_media from './stores/social-media';
import technical_data from './stores/technical_data';
import trades from './stores/trades';
import transactions from './stores/transactions';
import user from './stores/user';

export const store = createStore({
    modules: {
        abonnement,
        abonnements,
        apitest,
        cart_products,
        cart,
        contentpage,
        contentpages,
        contentstream_types,
        contentstream,
        contentstream_user,
        contentstreams,
        countries,
        customers,
        error,
        invoices,
        languages,
        order,
        orders,
        payment_methods,
        post,
        posts,
        product_categories,
        product_group,
        product_groups,
        settings,
        social_media,
        transactions,
        user,
        price_targets,
        trades,
        discount_promotions,
        marketSymbols,
        technical_data,
        edit_mode,
        dashboard_banners,
        performance,
        aboutus,
        meta,
        authors
    }
});
